import { isEmpty } from 'lodash'
import { defaultExportMenu, getHorizontalGroupedSeries } from '../helpers'
export default ({ config, data, color, legendLabels }) => {
  const { labelColor } = color
  const {
    series,
    height,
    disabledLegend = false,
    disabledAnimations = false,
    exportingMenu,
    ...restConfig
  } = config
  const { title, yKey, scrollbar, scrollbarY } = restConfig

  const configuration = {
    type: 'XYChart',
    data,
    height,
    autoDispose: true,

    scrollbarX: {
      disabled: !scrollbar,
      parent: 'bottomAxesContainer'
    },
    scrollbarY: {
      disabled: !scrollbarY,
      parent: 'rightAxesContainer'
    },
    xAxes: [
      {
        type: 'ValueAxis',
        renderer: {
          maxLabelPosition: 0.98,
          labels: {
            fill: labelColor
          }
        },
        title: {
          text: title || null,
          fill: labelColor
        }
      }
    ],
    yAxes: [
      {
        type: 'CategoryAxis',
        dataFields: {
          category: yKey
        },
        renderer: {
          cellStartLocation: 0.3, // columns width
          cellEndLocation: 0.7, // columns width
          grid: {
            template: {
              type: 'Grid',
              location: 0
            }
          },
          labels: {
            fill: labelColor
          },
          minGridDistance: 20
        }
      }
    ],
    series: getHorizontalGroupedSeries({
      series,
      otherConfig: { color, disabledAnimations, legendLabels, ...restConfig }
    }),
    legend: {
      useDefaultMarker: true,
      disabled: disabledLegend,
      labels: {
        text: '{name}',
        fill: labelColor
      },
      contentAlign: 'left',
      paddingTop: 10,
      paddingLeft: 45,
      markers: {
        children: [
          {
            width: 20,
            height: 20,
            fontSize: 200,
            strokeWidth: 0,
            paddingTop: 2.5,
            marginLeft: 22.5,
            paddingLeft: 2.5,
            strokeOpacity: 0,
            paddingRight: 2.5,
            paddingBottom: 2.5,
            cornerRadiusTopLeft: 0,
            cornerRadiusTopRight: 0,
            cornerRadiusBottomLeft: 0,
            cornerRadiusBottomRight: 0
          }
        ]
      }
    }
  }

  // Export menu
  if (exportingMenu && exportingMenu.enabled) {
    if (isEmpty(exportingMenu.config)) {
      configuration.exporting = defaultExportMenu
    } else {
      configuration.exporting = exportingMenu.config
    }
  }

  return configuration
}
